<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Salones</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nuevo Salón
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="classroomsWithBuilding"
        :fields="fields"
      >
        <template #cell(edificio)="data">
          {{ data.value.nombre }}
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
            {{ data.value ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteClassroom(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <classroom-modal
      :classroom-data="selectedClassroom"
      :buildings="buildings"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge,
} from 'bootstrap-vue'
import ClassroomModal from '@/components/classrooms/ClassroomModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import salonesService from '@/services/salonesService'
import edificiosService from '@/services/edificiosService'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    ClassroomModal,
  },
  data() {
    return {
      fields: [
        { key: 'numero', label: 'Número', sortable: true },
        { key: 'edificio', label: 'Edificio', sortable: true },
        { key: 'capacidad', label: 'Capacidad', sortable: true },
        { key: 'capacidadMaxima', label: 'Cap. Máxima', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      buildings: [],
      classrooms: [],
      selectedClassroom: null,
      loading: false,
    }
  },
  async mounted() {
    await this.loadData()
  },
  computed: {
    classroomsWithBuilding() {
      return this.classrooms.map(c => ({
        ...c,
        edificio: this.buildings.find(b => b.edificioId === c.edificioId),
      }))
    },
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        await Promise.all([
          this.loadBuildings(),
          this.loadClassrooms()
        ])
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al cargar los datos',
          },
        })
      } finally {
        this.loading = false
      }
    },
    async loadBuildings() {
      try {
        const response = await edificiosService.getAll()
        this.buildings = response
      } catch (error) {
        console.error('Error al cargar edificios:', error)
        throw error
      }
    },
    async loadClassrooms() {
      try {
        const response = await salonesService.getAll()
        this.classrooms = response
      } catch (error) {
        console.error('Error al cargar salones:', error)
        throw error
      }
    },
    openModal(item) {
      this.selectedClassroom = item ? { ...item } : null
      this.$bvModal.show('classroom-modal')
    },
    async handleModalSubmit(data) {
      try {
        if (data.salonId) {
          // Actualizar salón existente
          await salonesService.update(data.salonId, data)
        } else {
          // Crear nuevo salón
          await salonesService.create(data)
        }
        
        await this.loadClassrooms()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operación Exitosa',
            icon: 'CheckIcon',
            variant: 'success',
            text: `El salón se ha ${data.salonId ? 'actualizado' : 'creado'} correctamente.`,
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al procesar la operación',
          },
        })
      }
    },
    async deleteClassroom(item) {
      this.$swal({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡elimínalo!',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await salonesService.delete(item.salonId)
            await this.loadClassrooms()
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Eliminado',
                icon: 'TrashIcon',
                variant: 'success',
                text: 'El salón ha sido eliminado.',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Error al eliminar el salón',
              },
            })
          }
        }
      })
    },
  },
}
</script>
